import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setPhpackagingmaterialFilterCriteria } from 'store/slice/PharmaSlice';

export default function PhpackagingmaterialFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phpackagingmaterialDashboard);
        
    const {phproductformList} = useSelector((state)=>state.pharmaslice);
    
const updateTitleCriteria = (title) =>{
        dispatch(setPhpackagingmaterialFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateFormidCriteria = (formid) =>{
        dispatch(setPhpackagingmaterialFilterCriteria(
            {
                ...filterCriteria,
                formid:formid
        }))
    }
const updateFormnameCriteria = (formname) =>{
        dispatch(setPhpackagingmaterialFilterCriteria(
            {
                ...filterCriteria,
                formname:formname
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Title"
                            name="title"
                            value={filterCriteria.title}
                            onChange={(e)=>updateTitleCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item padding={1}>
                        <FormControl  style={{minWidth: 250}} size="small">
                        <InputLabel id="ratinginput">Form Id</InputLabel>
                        <Select
                            labelId="formidselect"
                            id="formid"
                            value={filterCriteria.formid}
                            name="formid"
                            label="Form Id"
                            onChange={(e)=>updateFormidCriteria(e.target.value)}
                            defaultValue={filterCriteria.producttypeid}
                            >
                            <MenuItem value="">None</MenuItem>
                            {
                                phproductformList && phproductformList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                            }
                        </Select>
                    </FormControl>
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Formname"
                            name="formname"
                            value={filterCriteria.formname}
                            onChange={(e)=>updateFormnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}